import Cookies from "js-cookie";

const LOGIN_PATH = "/login";
const REDIRECT_PARAM_KEY = "post_login_redirect";
const TOKEN_COOKIE = "token_jwt";

export function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    const json = decodeURIComponent(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(json);
  } catch (e) {
    console.error("Gagal decode JWT:", e);
    return null;
  }
}

export function isAuthenticated() {
  return !!Cookies.get(TOKEN_COOKIE);
}

export function getTokenJwt() {
  return Cookies.get(TOKEN_COOKIE) || null;
}

export function getUserLogin() {
  try {
    return JSON.parse(localStorage.getItem("userLogin") || "null");
  } catch {
    return null;
  }
}

export function goToLogin(intendedPath) {
  const target =
    intendedPath || window.location.pathname + window.location.search;
  localStorage.setItem(REDIRECT_PARAM_KEY, target);
  window.location.href = LOGIN_PATH;
}

export function clearSession() {
  Cookies.remove(TOKEN_COOKIE, { path: "/" });
  localStorage.removeItem("userLogin");
  // sisa migrasi lama (token pernah disimpan di localStorage)
  localStorage.removeItem("token_jwt");
}

export function saveSession(tokenJwt, userLogin) {
  clearSession();
  Cookies.set(TOKEN_COOKIE, tokenJwt, { expires: 1, path: "/" }); // 1 hari
  localStorage.setItem("userLogin", JSON.stringify(userLogin || {}));
}

export function setTokenCookie(tokenJwt) {
  Cookies.set(TOKEN_COOKIE, tokenJwt, { expires: 1, path: "/" });
}

export function consumePostLoginRedirect() {
  const target = localStorage.getItem(REDIRECT_PARAM_KEY) || "/dashboard";
  localStorage.removeItem(REDIRECT_PARAM_KEY);
  return target;
}

export function logout() {
  clearSession();
  window.location.href = LOGIN_PATH;
}
